import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstVdt: [],
        vdt: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getVdt(state) {
            return state.vdt
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, vdt) {
            state.vdt = vdt
            if (vdt)
                state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.vdt = null
        },
        setParamsDataTable(state, payload) {
            state.lstVdt = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setVdt(state, vdt) {
            state.vdt = vdt
        },
        setLstVdt(state, lstVdt) {
            state.lstVdt = lstVdt
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async findVdtOpercom({ commit, dispatch }) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/OryxPlace/CylinderMovement/FindVdtOpercom`)
                .then(response => {
                    let vdtopercom = Utils.ValidateAxiosResponse(response.data);
                    commit("set", vdtopercom)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
    }
}